(function () {
  const modal = document.getElementById('lens-type-modal');
  const closeBtn = document.getElementById('LensTypeModalClose');
  const openBtns = document.querySelectorAll('[data-lens-type-learn-more]');

  if (!modal) return;

  function updateAnnouncementBarHeight() {
    const announcementBar =
      document.querySelector('.announcement-bar') ||
      document.querySelector('[class*="announcement"]');
    const headerGroup = document.querySelector(
      '.shopify-section-group-header-group'
    );
    let height = 0;

    if (headerGroup) {
      height = headerGroup.offsetHeight;
    } else if (announcementBar) {
      height = announcementBar.offsetHeight;
    }

    modal.style.setProperty('--announcement-bar-height', height + 'px');
  }

  function openModal(e) {
    e.preventDefault();
    updateAnnouncementBarHeight();
    modal.showModal();
    document.body.classList.add('tw-overflow-hidden');
  }

  function closeModal() {
    if (window.innerWidth <= 999) {
      modal.classList.add('is-closing');
      modal.addEventListener('transitionend', function handler() {
        modal.classList.remove('is-closing');
        modal.close();
        document.body.classList.remove('tw-overflow-hidden');
        modal.removeEventListener('transitionend', handler);
      }, { once: true });
    } else {
      modal.close();
      document.body.classList.remove('tw-overflow-hidden');
    }
  }

  // Open modal on "Learn more" click
  openBtns.forEach((btn) => btn.addEventListener('click', openModal));

  // Close modal
  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  // Close on click outside (backdrop)
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  // Close on ESC key (native dialog behavior, but also remove body class)
  modal.addEventListener('close', () => {
    document.body.classList.remove('tw-overflow-hidden');
  });
})();
